<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { WorkOrderAssignmentRow } from "../../contract"
  import RequesterHintsCell from "./_modules/requester-hints-cell"

  let props: InboxWorkflowCellProps = $props()

  const row = $derived(props.row as unknown as WorkOrderAssignmentRow)
</script>

<RequesterHintsCell {row} />
